// Copyright 2026 EPAM Systems, Inc. ("EPAM")
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { z } from 'zod'

export const ProjectSchema = z.object({
  name: z.string(),
  display_name: z.string().max(150).nullable().optional(),
  description: z.string().optional(),
  project_type: z.string().optional(),
  created_by: z.string().optional(),
  created_at: z.string().optional(),
})

export type Project = z.infer<typeof ProjectSchema>
